import { render, staticRenderFns } from "./tableData.vue?vue&type=template&id=88f42928"
import script from "./tableData.ts?vue&type=script&lang=ts&external"
export * from "./tableData.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports